

import React from 'react'
import Registration from '../Components/Registration/Registration'
import Advertisement1 from '../Components/Advertisement1/Advertisement1'
import Advertisement2 from '../Components/Advertisement2/Advertisement2'


const Registrationpage = () => {
  return (
    <div>
      <Registration/>
      <Advertisement1/>
      <Advertisement2/>
    </div>
  )
}

export default Registrationpage
